import { render, staticRenderFns } from "./monitoria-produto.vue?vue&type=template&id=4645d536&"
import script from "./monitoria-produto.js?vue&type=script&lang=js&"
export * from "./monitoria-produto.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports